import React from 'react';
import { CSSProperties, HTMLAttributes } from 'react';
import { Property } from 'csstype';
import { AnyObject } from 'antd/es/_util/type';

export type ChildrenProps = HTMLAttributes<HTMLOrSVGElement>;

export type CustomComponent<P = AnyObject> = React.ComponentType<P> | string;

export interface FlexProps<P = AnyObject> extends React.PropsWithChildren<ChildrenProps> {
  component?: CustomComponent<P>;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  direction?: CSSProperties['flexDirection'];
  gap?: number | string;
  noGap?: boolean;
  wrap?: Property.FlexWrap;
  inlineFlex?: boolean;
  value?: any;
}

export const Flex = React.forwardRef<HTMLElement, FlexProps>((props, ref) => {

  let {
    style,
    children,
    align: alignItems,
    justify: justifyContent,
    direction: flexDirection,
    component: Cmp = 'div',
    gap = '8px',
    noGap = false,
    inlineFlex = false,
    wrap = undefined,
    value = undefined,
    ...rest
  } = props;

  if (noGap) {
    gap = 0;
  }
  const styles = {
    gap,
    justifyContent,
    alignItems,
    flexWrap: wrap,
    ...style,
    display: inlineFlex ? 'inline-flex' : 'flex',
    flexDirection,
  } as any;
  if (value) {
    styles.flex = value;
  }
  return (
    <Cmp {...rest} ref={ref} style={styles}>
      {children}
    </Cmp>
  );
});

export default Flex;
